// Internal modules
import { logger, once } from '@/lib';

// Only log to FPTI the first time the user click the show cart button
export const logShowCartOnce = once((cartDetailsItemLength, total) => {
  logger.fpti('weasley_show_cart_dropdown', {
    amt: total?.currencyFormat,
    currency_code: total?.currencyCode,
    pu_item_cnt: cartDetailsItemLength ?? '0',
    state_name: 'BILLING',
    transition_name: 'clicked_item_cart',
  });
});
